(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceDeleteController',NasracSourceDeleteController);

    NasracSourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracSource'];

    function NasracSourceDeleteController($uibModalInstance, entity, NasracSource) {
        var vm = this;

        vm.nasracSource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, sourceName) {
            NasracSource.delete({id: id, sourceName: sourceName},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
